import * as React from "react";

interface SidebarSectionProps {
  icon: string;
  label: string;
  children: React.ReactNode;
  className?: string;
}

const SidebarSection: React.FC<SidebarSectionProps> = ({ icon, label, children, className = "" }) => (
  <div className={`d-flex flex-column p-4 border-bottom gap-3 ${className}`.trim()}>
    <div className="d-flex align-items-center">
      <span className="icon icon-lg">{icon}</span>
      <span className="fs-18 fw-medium">{label}</span>
    </div>
    {children}
  </div>
);

export default SidebarSection;
